module.exports = __webpack_public_path__ + "static/media/price_free.3188e7b3.png";